var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6682 9.77832V14.2228H49.7793V36.445H54.2237V14.2228C54.2237 11.7672 52.2349 9.77832 49.7793 9.77832H18.6682ZM14.2237 18.6672C11.7793 18.6672 9.801 20.6672 9.801 23.1117L9.7793 56.445L18.6682 47.5561H40.8904C43.3349 47.5561 45.3349 45.5561 45.3349 43.1117V23.1117C45.3349 20.6672 43.3349 18.6672 40.8904 18.6672H14.2237Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3442 36.4982H26.0857L25.5725 24.6221H29.8574L29.3442 36.4982ZM25.4531 40.1982C25.4531 39.6094 25.664 39.128 26.0857 38.754C26.5154 38.3721 27.0485 38.1811 27.6851 38.1811C28.3217 38.1811 28.8508 38.3721 29.2726 38.754C29.7023 39.128 29.9171 39.6094 29.9171 40.1982C29.9171 40.7871 29.7023 41.2725 29.2726 41.6544C28.8508 42.0284 28.3217 42.2154 27.6851 42.2154C27.0485 42.2154 26.5154 42.0284 26.0857 41.6544C25.664 41.2725 25.4531 40.7871 25.4531 40.1982Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechIcon);
export default __webpack_public_path__ + "static/media/speechIcon.858a9ca41a1457fb50fae8d7f06596cd.svg";
export { ForwardRef as ReactComponent };